import request from "../../helpers/request"

export const getGruposMonitoramento = async () => {
  const url = `${process.env.REACT_APP_API}/GrupoMonitor`
  const result =  await request({ url })
  return result.data
}